/* eslint-disable complexity */
export function calculateHoursSum(values: string[]) {
  let hours: number = 0;
  let minutes: number = 0;
  // wenn ein Wert im Arry nicht den format H..H:MM enstspricht keine Berechnung
  values.forEach((val) => {
    if (val === '') return;
    if (!val.match(/^$|^\d+(?::\d{0,2})?$/)) return;
    const [h, m] = val.split(':');
    hours += parseInt(h);
    minutes += m ? parseInt(m) : 0;

    while (minutes >= 60 && minutes % 60 >= 0) {
      const rest = minutes % 60;
      if (rest >= 0) minutes -= 60;
      hours += 1;
    }
  });

  return `${hours}:${minutes.toString().padStart(2, '0')}`;
}
